import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { loadTemplateInstallationRequests, loadTemplateInstallationRequestsFailed, loadTemplateInstallationRequestsSuccess } from "../actions/templates/template-installation-requests.actions";
import { catchError, map, mergeMap } from "rxjs";
import { TemplateInstallationRequestsService } from "src/app/services/template-installation-requests/template-installation-requests.service";
import { parseFrontEndObjectProperties } from "src/app/models/workflow-request.model";
import { parseInstallationRequestProperties } from "src/app/models/template-installation-requests.model";
import { SignalRService } from "src/app/services/signal-r/signal-r.service";

@Injectable()
export class TemplateInstallationRequestsEffects {
    private actions$ = inject(Actions);
    private templateInstallationRequestsService = inject(TemplateInstallationRequestsService);
    private signalRService = inject(SignalRService);


    // Load the workflows from backend blob storage
    loadTemplateInstallationRequests$ = createEffect(() => this.actions$.pipe(
        ofType(loadTemplateInstallationRequests),
        mergeMap(() =>
            this.templateInstallationRequestsService.loadTemplateInstallationRequests().pipe(
                map(resp => {
                    if (resp.data) {
                        resp.data.forEach(request => {

                            if (request.type === 'WorkflowRequest') {
                                parseFrontEndObjectProperties(request)
                            }
                            else {
                                parseInstallationRequestProperties(request)
                            }
                        })
                    }
                    // Init signalR for workspace template installations
                    this.signalRService.addWorkspaceTemplateInstallationsListener()
                    return loadTemplateInstallationRequestsSuccess({ installationRequests: resp.data });
                }),
                catchError(async (error) => loadTemplateInstallationRequestsFailed({ error: error })),
            )
        )
    ));
}